import { useContainer } from "./useContainer"

export const useRoutes = () => [...useContainer().routesSales, ...useContainer().routesOnePortal]
